var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$props.tagname,_vm._g({tag:"section",staticClass:"ps-container",on:{"~mouseover":function($event){return _vm.update($event)}}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }